import React, { ReactElement } from "react";
import Dropzone from "react-dropzone";
import { Application } from "../applications";
import { ApplicationService } from "./ApplicationService";

interface IProps {
	application: Application;
	fileIdentifier: string;
	onUploadComplete: () => void;
}

export const ApplicationDropzone = (props: IProps): ReactElement => {
	const applicationService = new ApplicationService();

	return (
		<Dropzone
			onDrop={async acceptedFiles => {
				await applicationService.uploadFiles(
					props.application,
					acceptedFiles,
					props.fileIdentifier,
				);

				props.onUploadComplete();
				return acceptedFiles;
			}}
		>
			{({ getRootProps, getInputProps }) => (
				<section className="dropzone">
					<div {...getRootProps()}>
						<input {...getInputProps()} />
						Drag &amp; drop files here, or click to select files
					</div>
				</section>
			)}
		</Dropzone>
	);
};
